module.exports = __webpack_public_path__ + "static/media/kudos-left-arrow-icon.fedcb9cc.svg";